import React from 'react';
import './search.scss';

const Search = (props) => {
  const busca = props.busca;
  const channelSearch = props.channelSearch;
  const clearSearch = props.clearSearch;
  const canaisDoPlano = props.canaisDoPlano;

  return (
    <div className="mdn-Input">
      <input
        id="search"
        className="mdn-Input-field"
        type="text"
        data-mdn-type="search"
        value={busca}
        onChange={channelSearch}
      />
      <label htmlFor="search" className={`mdn-Input-label ${busca.length > 0 ? `ativo` : ``}`}>
        Busque no plano {canaisDoPlano}
      </label>
      {busca.length > 1 && (
        <button className="mdn-Input-action" onClick={clearSearch}>
          <i className="mdn-Icon-fechar mdn-Icon--md"></i>
        </button>
      )}
    </div>
  );
};

export default Search;
